// rent-channel
import { axios } from '../index'

let scope = 'rent'

// 产生api方法
// function axiosFactory(url, params) {
//   return axios.post(
//     `${scope}${url}`, params
//     )
// }

export default {
  // 费用列表相关
  planfee: {
    // 生成收款二维码，返回为base64的图片码
    listByBussinessId(params) {
      return axios.post(`/${scope}/planfee/listByBusinessId`, params)
    },
    // 提前生成账单列表
    billAdvanceCreatedByBusinessId: params =>
      axios.post(
        `/${scope}/chargrule/listNotCreateOrder
      `,
        params
      ),
  },
  // 租约相关的合同信息
  lease: {
    // 根据租约ID获取租期（退租流程 退租办理）
    getThrowMessage(params) {
      return axios.get(`/${scope}/lease/get/${params}`)
    },
    // 根据合同Id 获得租约Id
    getLeaseId: id => axios.get(`/${scope}/lease/getLeaseIdByContractId/${id}`),
  },
  // 计费规则
  chargeRule: {
    getChargeRuleAdd: params => axios.post(`${scope}/chargrule/add`, params),
  },
  // 托管信息
  delegate: {
    // 根据合同Id 获得托管Id
    getDelegateId: id => axios.get(`/${scope}/delegate/getByContractId/${id}`),
  },
  // 根据用户Id 查询预订
  getReservationByUserId: userId =>
    axios.get(`/${scope}/reservation/getResByUserId/${userId}`),
  // 获取 租赁列表数据
  getLeaseList: params => axios.post(`/${scope}/lease/list`, params),
  // 录入优惠提交按钮
  preferential: params => axios.post(`/${scope}/chargrule/add/list`, params),
  // 租赁管理 添加备注信息
  addTips: params => axios.post(`/${scope}/lease/appendMmeo`, params),

  reservation: {
    backToEffect({id, delayDays}) {
      return axios.get(`/${scope}/reservation/backToEffect/${id}/${delayDays}`)
    }
  },
  addBillType: params => 
  axios.post(
    `/${scope}/algorithm/calculateEachBill`,
    params
  ),  
  // 计算时间
  compTime: params => 
  axios.post(
    `/${scope}//algorithm/calculateCycle`,
    params
  ), 
  // 删除抵扣
  checkDepositDeduct(params) {
    return axios.get(`/pay/order/queryUnusedDisc/${params}`)
  },
  delDeduction: params => axios.post(`/pay/order/delUnusedDisc`, params),
  // 查询未支付的房东账单接口
  queryUnPayLandlord: params => axios.post(`/${scope}/delegate/queryUnPayLandlord`, params),
  // 拆分房东账单接口
  splitLandlordOrder: params => axios.post(`/${scope}/delegate/splitLandlordOrder`, params)
}



// WEBPACK FOOTER //
// ./src/xhr/services/rent.js